import { content } from 'html2canvas/dist/types/css/property-descriptors/content';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  EOtpremnicaForm,
  EotpremnicaFormService,
} from '../eotpremnica-form.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import {
  CreateEOtpremnicaCommand,
  EOtpremniceClient,
  IAdresaIsporukeDto, IEOtpremnicaAutocompleteResponse,
  JedinicaMere,
  NacinOtpreme,
  PretovarIsporukeCommand,
  RacuniClient,
  StatusEOtpremnice,
  TipOtpremnice,
  TipRacuna,
  UpdateEOtpremnicaCommand
} from '@kodit/core/data-api';
import {
  AlertService,
  LocationService,
  SharedService,
} from '@kodit/core/services';
import { ConfirmationService } from 'primeng/api';
import { FormHelper } from '@kodit/core/form-definitions';
import { finalize } from 'rxjs/operators';
import { FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'kodit-eotpremnica-form',
  templateUrl: './eotpremnica-form.component.html',
  styleUrls: ['./eotpremnica-form.component.scss'],
})
export class EotpremnicaFormComponent implements OnInit, OnDestroy, AfterViewInit {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  form!: EOtpremnicaForm;
  ctrlPlaceholder: string = 'Unesite broj otpremnice';
  tipRacuna : TipRacuna = TipRacuna.EOTPREMNICA

  robaTreceStraneSuggestions: IEOtpremnicaAutocompleteResponse[] = [];

  jeInterna = false;
  jePretovar = false;

  @ViewChild('scrollTarget') scrollTarget!: ElementRef;
  @ViewChild('magacinOtpremeWrapper') magacinOtpremeWrapper!: ElementRef;

  magacinRequiredHighlight = false;

  constructor(
    private _fs: EotpremnicaFormService,
    private _route: ActivatedRoute,
    private _locationService: LocationService,
    private _confirmationService: ConfirmationService,
    private _client: EOtpremniceClient,
    private _formHelper: FormHelper,
    private _sharedService: SharedService,
    private _alert: AlertService,
    private _clentRacun: RacuniClient
  ) {}

  ngOnInit(): void {
    this.form = this._fs.getForm(this._route.snapshot.data['otpremnica']);

    if (this._fs.jePretovarEditSubject.value || this.form?.controls.status?.value == StatusEOtpremnice.POSLATO) {
      this.form.disable();
      this.form.controls['fazeVoznjeDto'].enable();
      this.jePretovar = true;
    }

    this._fs.setOtpremnicaForm = this.form;
    this._fs.setTipOtpremnice(this.form?.controls.tipOtpremnice.value);
    this._fs.setNacinOtpreme(this.form?.controls.nacinOtpreme.value);

    if(this._fs.jeEdit)
    {
      this.ctrlPlaceholder = this.form?.value.brojOtpremniceTrecaStrana
    }

    // if(this.form?.controls.adresaOtpremeDto?.value.magacinId === null){
    //   debugger
    //   this.form?.controls['stavkeDto']?.disable();
    // }
  }

  ngAfterViewInit(): void {
    if (this._fs.jePretovarEditSubject.value || this.form?.controls.status?.value == StatusEOtpremnice.POSLATO) {
      this.scrollTarget.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }

  onTipChange(event: TipOtpremnice) {
    this._fs.setTipOtpremnice(event);
    if (event == TipOtpremnice.INTERNA) {
      this.jeInterna = true;
      this._subs.add(
        this._clentRacun.searchStrankaRacuna(null, true).subscribe((res) => {
          if (res.succeeded) {
            this._fs.setStrankaOtpremnice = res.data?.strankaRacunaDtoList?.[0];
          }
        })
      );
    } else {
      this.jeInterna = false;
      this._fs.getStrankaEOtpremniceFormGroup.reset();
    }
  }

  onNacinOtpremeChange(event: NacinOtpreme) {
    this._fs.setNacinOtpreme(event);
  }

  handleRouteBack() {
    this._locationService.routeBack();
  }

  evidentirajPretovar() {
    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    const command = {
      otpremnicaId: this.form?.controls.id?.value,
      fazeVoznje: this.form?.controls.fazeVoznjeDto?.value
    };

    this._sharedService.displayLoadingScreen(true, "Evidentiranje neplaniranog pretovara u toku");
    this._subs.add(
      this._client
        .evidencijaPretovara(command as PretovarIsporukeCommand)
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          if(res.succeeded){
            this._alert.addSuccessMsg(res.messages[0]);
            this._locationService.routeToCancelEOtpremnica();
            return;
          }
          this._alert.addFailedMsg(res.messages[0]);
        })
    );
    this._fs.setJePretovarEdit(false);
  }

  handleCancel() {
    this._confirmationService.confirm({
      message: 'Ukoliko otkažete sav nesnimljen sadržaj će biti izgubljen.',
      acceptLabel: 'Otkaži',
      rejectLabel: 'Ostani na stranici',
      header: 'Potvrdite otkazivanje',
      icon: 'far fa-check-circle',
      rejectButtonStyleClass: 'p-button-outlined',
      accept: () => {
        this._locationService.routeToCancelEOtpremnica();
      },
    });
  }

  handleSave() {
    this.setVrednosti();
    const cleanedValue = this._cleanForBackend(this.form?.value);
    this.setValidatorsJediniceMere();

    if(!this._validacijaDatuma()){
      return;
    }

    if (!this.form!.valid) {
      this._formHelper.invalidateForm(this.form!);
      return;
    }

    if(this.form?.controls.adresaOtpremeDto?.value?.magacinId == null)
    {
      this._alert.addWarnMsg("Morate izabrati magacin adrese otpreme.")
      return;
    }

    if(this.form?.controls.imaOpasneMaterije?.value &&
      !(this.form?.controls.opasneMaterijeDto?.value ?? []).some((m: any) => (m?.naziv ?? '').trim() !== ''))
    {
      this._alert.addWarnMsg("Označeno je da otpremnica sadrži opasne materije. Unesite najmanje jednu opasnu materiju ili isključite tu opciju.")
      return;
    }

    if(this.form?.controls.fazeVoznjeDto?.value.length > 0)
    {
      if(!this._validacijaFazaVoznje()){
        this._alert.addWarnMsg("Neispravna veza između faza vožnje: mesto utovara naredne faze mora odgovarati mestu isporuke prethodne faze.")
        return;
      }
    }

    if (this.form?.controls.robaTreceStrane != null) {
      this.form.controls.jeRobaTreceStrane?.patchValue(true);
    }

    if (this._fs.jeEdit) {
      this._sharedService.displayLoadingScreen(true, 'Ažuriranje otpremnice...');
      this._subs.add(
        this._client
          .updateEOtpremnica(
            this.form?.value.id,
            cleanedValue as UpdateEOtpremnicaCommand
          )
          .pipe(
            finalize(() => {
              this._sharedService.resetLoadingScreen();
            })
          )
          .subscribe((res) => {
            if (res.succeeded) {
              this._alert.addSuccessMsg(res.data);
              this._locationService.routeBack();
            }
            this._alert.addFailedMsg(res.messages![0]);
          })
      );
    } else {
      this._sharedService.displayLoadingScreen(true, 'Kreiranje otpremnice...');
      this._subs.add(
        this._client
          .create(cleanedValue as CreateEOtpremnicaCommand)
          .pipe(
            finalize(() => {
              this._sharedService.resetLoadingScreen();
            })
          )
          .subscribe((res) => {
            if (res.succeeded) {
              this._alert.addSuccessMsg('Uspešno kreirana otpremnica');
              this._locationService.routeBack();
            }
            this._alert.addFailedMsg(res.messages![0]);
          })
      );
    }
  }

  onSelectionAdresaOtpremeChange(adresa: IAdresaIsporukeDto) {
    this._fs.setAdresaOtpreme = adresa;
    this.magacinRequiredHighlight = false;
  }

  scrollToMagacinOtpreme(): void {
    this.magacinRequiredHighlight = true;
    this.magacinOtpremeWrapper?.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }

  onSelectionAdresaOtpremeClear() {
    this.form?.controls.adresaOtpremeDto?.reset();
  }

  onSelectionAdresaOdredistaChange(adresa: IAdresaIsporukeDto) {
    this._fs.setAdresaOdredista = adresa;
  }

  onSelectionAdresaOdreditsaClear() {
    this.form?.controls.adresaOdredistaDto?.reset();
  }


  private _cleanForBackend(value: any): any {
    const cleaned = JSON.parse(JSON.stringify(value));

    if (
      cleaned.licniNacinOtpreme &&
      Object.values(cleaned.licniNacinOtpreme).every(
        (v) => v === null || v === ''
      )
    ) {
      cleaned.licniNacinOtpreme = null;
    }

    if (
      cleaned.posiljalacKontaktDto &&
      Object.values(cleaned.posiljalacKontaktDto).every(
        (v) => v === null || v === ''
      )
    ) {
      cleaned.posiljalacKontaktDto = null;
    }

    if (
      cleaned.primalacKontaktDto &&
      Object.values(cleaned.primalacKontaktDto).every(
        (v) => v === null || v === ''
      )
    ) {
      cleaned.primalacKontaktDto = null;
    }

    if (Array.isArray(cleaned.stavkeDto)) {
      cleaned.stavkeDto = cleaned.stavkeDto.map((stavka: any) => {
        if (
          stavka.akciznaKategorijaDto &&
          Object.values(stavka.akciznaKategorijaDto).every(
            (v) => v === null || v === ''
          )
        ) {
          stavka.akciznaKategorijaDto = null;
        }
        return stavka;
      });
    }

    // Opasne materije: ako flag nije cekiran -> prazna lista; inace izbaci prazne redove (bez naziva)
    if (!cleaned.imaOpasneMaterije) {
      cleaned.opasneMaterijeDto = [];
    } else if (Array.isArray(cleaned.opasneMaterijeDto)) {
      cleaned.opasneMaterijeDto = cleaned.opasneMaterijeDto.filter(
        (m: any) => (m?.naziv ?? '').trim() !== ''
      );
    }

    return cleaned;
  }

  changeJedinicaTezina(event: JedinicaMere): void {
    if (event !== null) {
      this.form?.controls.tezinaIsporuke?.setValidators([Validators.required]);
      this.form?.controls.tezinaIsporuke?.updateValueAndValidity();
    } else {
      this.form?.controls.tezinaIsporuke?.clearValidators();
      this.form?.controls.tezinaIsporuke?.updateValueAndValidity();
    }
  }

  changeJedinicaZapremina(event: JedinicaMere): void {
    if (event !== null) {
      this.form?.controls.zapreminaIsporuke?.setValidators([
        Validators.required,
      ]);
      this.form?.controls.zapreminaIsporuke?.updateValueAndValidity();
    } else {
      this.form?.controls.zapreminaIsporuke?.clearValidators();
      this.form?.controls.zapreminaIsporuke?.updateValueAndValidity();
    }
  }

  private setVrednosti(): void {
    this._fs.getStavkeArray.controls.forEach(stavka => {
      const akciza = stavka.get('akciznaKategorijaDto') as FormGroup;
      const vrednostCtrl = akciza.get('vrednost');

      if (vrednostCtrl?.value !== null && vrednostCtrl?.value !== undefined) {
        vrednostCtrl.setValue(String(vrednostCtrl.value));
      }
    });
  }

  setValidatorsJediniceMere(): void {
    const setValidator = (controlName: string, unitControlName: string) => {
      const control = this.form?.controls[controlName];
      const unitControl = this.form?.controls[unitControlName]?.get('id');

      if (!unitControl) return;

      if (control?.value != null) {
        unitControl.setValidators([Validators.required]);
      } else {
        unitControl.clearValidators();
      }
      unitControl.updateValueAndValidity();
    };

    setValidator('zapreminaIsporuke', 'jedinicaMereZapreminaDto');
    setValidator('tezinaIsporuke', 'jedinicaMereTezinaDto');
  }

  private _validacijaFazaVoznje(): boolean {
    const faze = this.form?.controls.fazeVoznjeDto?.value;

    if (!Array.isArray(faze) || faze.length === 0) {
      return true;
    }

    for (let i = 1; i < faze.length; i++) {
      const prethodna = faze[i - 1];
      const trenutna = faze[i];

      if (trenutna.mestoUtovara.trim() !== prethodna.mestoIsporuke.trim()) {
        return false;
      }
    }

    return true;

  }


  private _validacijaDatuma(): boolean {
    if (!this.form)
    {
      return false;
    }
    const now = new Date();

    const planiraniPocetak: Date | undefined = this.form?.controls.planiraniDatumPocetka?.value;
    const planiraniKraj: Date | undefined = this.form?.controls.planiraniDatumZavrsetka?.value;
    const stvarniDatum: Date | undefined = this.form?.controls.stvarniDatum?.value;

    if (!planiraniPocetak || !planiraniKraj || !stvarniDatum) {
      this._alert.addWarnMsg("Datumi nisu validni");
      console.log('Pocetak: ' + planiraniPocetak?.toString())
      console.log('Kraj: ' + planiraniKraj?.toString())
      console.log('Stvarni datum: ' + stvarniDatum?.toString())
      return false;
    }

    const normalize = (d: Date) => new Date(d).setSeconds(0, 0);
    const nowNorm = normalize(now);

    const isPast = (d: Date) => d && normalize(d) < nowNorm;

    if (isPast(planiraniPocetak) || isPast(planiraniKraj) || isPast(stvarniDatum)) {
      this._alert.addWarnMsg("Datumi ne smeju biti u prošlosti.");
      return false;
    }

    if (planiraniPocetak && planiraniKraj && normalize(planiraniKraj) <= normalize(planiraniPocetak)) {
      this._alert.addWarnMsg("Planirani datum završetka ne sme biti pre planiranog početka ili isti.");
      return false;
    }

    return true;
  }

  handleSearch(event: any) {
    this._subs.add(
      this._client
        .getEOtpremniceAutocomplete(event.query)
        .subscribe((result) => {
          this.robaTreceStraneSuggestions = [...result.data];
        })
    );
  }

  selectionChanged(value: IEOtpremnicaAutocompleteResponse) {
    this.form?.controls.robaTreceStrane?.patchValue(value.eOtpremnicaSefId);
    this.form?.controls.robaTreceStrane?.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
    this._fs.resetForm();
    this._fs.setJePretovarEdit(false);
  }
}
